export enum MaterialSide {
  FRONT = "front",
  BACK = "back",
  DOUBLE = "double",
}
